module.exports = __webpack_public_path__ + "static/media/patent_jp.b443a121.9dc64101.jpg";